@if (name() && name().length > 0) {
<span class="cb-icon" [class.cb]="!external()" [ngClass]="name()!"></span>
}